module.exports = __webpack_public_path__ + "img/icon2.cbd8bb3c.svg";